import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
@Injectable()

export class Constants {
    public Server = environment.apiServerUrl;
    public ApiUrl = 'api/';
    public ServerWithApiUrl = this.Server + this.ApiUrl;
    public bankAuthUrl = `${environment.frotendUrl}bank/auth/`;
    public secureUrlLink = `${environment.frotendUrl}secure/url/`;
    public plaid_public_key = environment.plaid_public_key;
    //  public captcha_key = '6LfqpTkUAAAAANoCXOmtPUnOVcjqlBvDY2p3bCRH';   //it's for localhost  
    public captcha_key = environment.captcha_key; //it's for live server
    public APIKey = environment.APIKey;
    public APIPassword = environment.APIPassword;

}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/app.constants.ts